import { useMutation } from "@tanstack/react-query";
import { CreditPaymentPayload } from "../api/credit";
import { makeCreditPayment } from "../repositories/credit.repository";

export const useCredit = () => {
  const {
    mutate: makePayment,
    mutateAsync: makePaymentAsync,
    data,
    isPending,
    isSuccess,
    isError,
    error,
  } = useMutation({
    mutationFn: (payload: CreditPaymentPayload) => makeCreditPayment(payload),
  });

  return {
    makePayment,
    makePaymentAsync,
    data,
    isPending,
    isSuccess,
    isError,
    error,
  };
};
